const transitionCosts = {
    knowledgeTransfer: { cost: 300000, description: "Knowledge Transfer" },
    processDocumentation: { cost: 200000, description: "Process Documentation" },
    toolMigration: { cost: 250000, description: "Tool Migration" },
    projectManagement: { cost: 150000, description: "Project Management" },
    totalOneTimeCosts: 900000
  };
  
  export default transitionCosts;